import { PageFrame } from '@eo/shared';

// Rendered in `<Page>`'s header slot, so the page still names itself while the
// registries are loading or after they fail.
export function AdminChrome() {
  return (
    <PageFrame
      title="Admin"
      subtitle="Cross-CFO status, the operational registries, and the holiday calendar."
    />
  );
}
